import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useCarDocumentsApi } from "../../http/carDocuments/api";
import { CarDocument } from "../../http/carDocuments/types";
import ModalDialog from "../ui/ModalDialog";

type DeleteCarDocumentDialogProps = {
  carDocument: CarDocument;
  onClose: () => void;
};

const DeleteCarDocumentDialog: FC<DeleteCarDocumentDialogProps> = ({ carDocument, onClose }) => {
  const i18n = useI18n();
  const carDocumentsApi = useCarDocumentsApi();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);

  return (
    <ModalDialog
      onClose={onClose}
      title={i18n.t.documents.delete}
      isSubmitting={isSubmitting}
      actions={[
        {
          title: i18n.t.common.cancel,
          type: "secondary",
          onClick: onClose,
        },
        {
          title: i18n.t.common.yes,
          onClick: () => {
            setIsSubmitting(true);
            carDocumentsApi
              .deleteCarDocument(carDocument.id, carDocument.car.id)
              .then(() => {
                onClose();
                dispatch(showSuccessNotification(i18n.t));
              })
              .catch((err) => dispatch(showErrorNotification(i18n, err)))
              .finally(() => setIsSubmitting(false));
          },
        },
      ]}
    >
      {i18n.t.documents.questions.delete}
    </ModalDialog>
  );
};

export default DeleteCarDocumentDialog;
